export enum RECURRING_BOOKING_MODE {
  AUTO = 'AUTO',
  REQUEST = 'REQUEST',
  OFF = 'OFF',
}
